// extracted by mini-css-extract-plugin
export default {"cmsPagesContentWrapper":"CmsPagesEditModal_cmsPagesContentWrapper__nW-oB","trailContentWrapper":"CmsPagesEditModal_trailContentWrapper__+Oj4u"};